import "react-toastify/dist/ReactToastify.css"

import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/dist/ScrollTrigger"
import { type FC, useEffect, useState } from "react"
import { ToastContainer } from "react-toastify"

import AppProvider from "../providers/AppProvider"
import UserProvider from "../providers/UserProvider"
import { initAmplitude, stopCheckoutReplayFlow } from "../utils/amplitude"

let browserQueryClient: QueryClient | undefined

const getQueryClient = () => {
  if (typeof window === "undefined") {
    return new QueryClient()
  }

  browserQueryClient ??= new QueryClient()
  return browserQueryClient
}

const AppLayout: FC<{
  children: React.ReactNode
}> = ({ children }) => {
  const [queryClient] = useState(getQueryClient)

  useEffect(() => {
    initAmplitude()

    gsap.registerPlugin(ScrollTrigger)
  }, [])

  useEffect(
    () => () => {
      void stopCheckoutReplayFlow({ clearFlowMarker: false })
    },
    [],
  )

  return (
    <div className="h-full text-textPrimary">
      <QueryClientProvider client={queryClient}>
        <UserProvider>
          <AppProvider>
            {children}
            <ToastContainer />
          </AppProvider>
        </UserProvider>
      </QueryClientProvider>
    </div>
  )
}

export default AppLayout
